import PropTypes from 'prop-types';

const propTypes = {
};

export default propTypes;



// WEBPACK FOOTER //
// ./src/chat-sidebar/prop-types.js